import { gql } from "@apollo/client";

export const GET_ALL_TRANSACTIONS = gql`
  query GetAllTransactions($payload: getAllTransactionsPayload) {
    getAllTransactions(payload: $payload) {
      message
      meta {
        total
        currentPage
        lastPage
        size
      }
      data {
        id
        paymentLinkId
        productId
        organizationId
        quantity
        amount
        type
        paymentFrom
        payerEmail
        productName
        currency
        status
        createdAt
        updatedAt
      }
    }
  }
`;

export const GET_TRANSACTION_BY_ID = gql`
  query GetTransactionById($getTransactionByIdId: ID!) {
    getTransactionById(id: $getTransactionByIdId) {
      reference
      productId
      quantity
      price
      amount
      amount
      type
      paymentFrom
      payerEmail
      productName
      currency
      status
      createdAt
      updatedAt
      meta
    }
  }
`;

export const GET_TRANSACTION_BY_ORGANIZATION_ID = gql`
  query GetAllTransactionsByOrganizationId(
    $payload: getAllTransactionsByOrganizationIdPayload!
  ) {
    getAllTransactionsByOrganizationId(payload: $payload) {
      message
      meta {
        total
        currentPage
        lastPage
        size
      }
      data {
        id
        paymentLinkId
        productId
        organizationId
        quantity
        price
        amount
        type
        paymentFrom
        payerEmail
        productName
        currency
        status
        createdAt
        updatedAt
        reference
        meta
      }
    }
  }
`;
